export default __webpack_public_path__ + "static/media/learn_mid_bg.63ae033c.png";